<script>
  // lib
  import { createEventDispatcher } from "svelte";
  import { v4 as uuidv4 } from "uuid";

  // store
  import PollStore from "../stores/PollStore";

  // components
  import Button from "../shared/Button.svelte";

  let dispatch = createEventDispatcher();
  let fields = {
    question: "",
    answerA: "",
    answerB: ""
  };
  let errors = {
    question: "",
    answerA: "",
    answerB: ""
  };
  let valid = false;

  const onSubmit = () => {
    valid = true;
    fields.question = fields.question.trim();
    fields.answerA = fields.answerA.trim();
    fields.answerB = fields.answerB.trim();

    // validate question
    if (fields.question.length < 5) {
      valid = false;
      errors.question = "Question must be at least 5 characters long";
    } else {
      errors.question = "";
    }

    // validate answer A
    if (fields.answerA.length < 1) {
      valid = false;
      errors.answerA = "Answer A cannot be empty";
    } else {
      errors.answerA = "";
    }

    // validate answer B
    if (fields.answerB.length < 1) {
      valid = false;
      errors.answerB = "Answer B cannot be empty";
    } else {
      errors.answerB = "";
    }

    // add a new poll
    if (valid) {
      let poll = { ...fields, voteA: 0, voteB: 0, id: uuidv4() };
      // save poll to store
      PollStore.update((currentPolls) => {
        return [poll, ...currentPolls];
      });
      dispatch("add");
    }
  };
</script>

<form on:submit|preventDefault={onSubmit}>
  <div class="form-field">
    <label for="question">Poll Question</label>
    <input
      type="text"
      id="question"
      bind:value={fields.question}
      class:error-field={errors.question}
    />
    <div class="error-msg">{errors.question}</div>
  </div>
  <div class="form-field">
    <label for="answer-a">Answer A</label>
    <input
      type="text"
      id="answer-a"
      bind:value={fields.answerA}
      class:error-field={errors.answerA}
    />
    <div class="error-msg">{errors.answerA}</div>
  </div>
  <div class="form-field">
    <label for="answer-b">Answer B</label>
    <input
      type="text"
      id="answer-b"
      bind:value={fields.answerB}
      class:error-field={errors.answerB}
    />
    <div class="error-msg">{errors.answerB}</div>
  </div>
  <Button flat={true} fullWidth={false}>Add Poll</Button>
</form>

<style>
  form {
    width: 100%;
    max-width: 500px;
    margin: 0 auto;
    text-align: center;
  }
  .form-field {
    margin: 18px auto;
  }
  input {
    width: 100%;
  }
  label {
    margin: 5px auto;
    text-align: left;
  }
  .error-field {
    border-color: #dc3545;
    margin-bottom: 0.3em;
  }
  .error-msg {
    text-align: left;
    font-size: 0.8em;
    color: #dc3545;
  }
</style>
